import { service } from "@/services/api.ts";
import { IUIConfigState } from "@/types/common";
import {
  GetViewProjectItemDetailRequest,
  GetViewProjectItemDetailResponse,
  GetViewProjectItemUIConfigResponse,
  ViewProjectItemDetailFilterResponse,
  ViewProjectItemDetailFiltersRequest
} from "@/types/majorProjects/projectItemsList";

const urlViewProjectItemDetailService = "customers/major-project/view-item/project-item";

export const viewProjectItemDetailService = {
  getViewProjectItemDetailFilters: (params: ViewProjectItemDetailFiltersRequest) =>
    service.post<ViewProjectItemDetailFilterResponse>(urlViewProjectItemDetailService + "/filters", params),
  getViewProjectItemDetailUIConfig: () => service.get<GetViewProjectItemUIConfigResponse>("/uiConfigs/MajorProject_Item"),
  updateViewProjectItemDetailUIConfig: (params: IUIConfigState) => service.put<GetViewProjectItemUIConfigResponse>("/uiConfigs", params),
  exportCSV: (params: GetViewProjectItemDetailRequest) =>
    service.post(urlViewProjectItemDetailService + "/exportCsv", params, { responseType: "blob" }),
  getViewProjectItemDetail: (params: GetViewProjectItemDetailRequest) =>
    service.post<GetViewProjectItemDetailResponse>(urlViewProjectItemDetailService + "/search", params)
};
